import { render, staticRenderFns } from "./TeIntro.vue?vue&type=template&id=5a4b2624&"
import script from "./TeIntro.vue?vue&type=script&lang=ts&"
export * from "./TeIntro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports